import { Stack, Tooltip } from "@mui/material"
import AccountTreeIcon from '@mui/icons-material/AccountTree';

export const SessionTreeField = ({ row }) => {
    const sessionID = row?.id;

    const haveChildSessions = () => {
        if (row?.ChildSessions != null && Object.keys(row?.ChildSessions).length > 0) {
            return true;
        }
        else {
            return false;
        }
    }

    const haveParentSession = () => {
        if (row?.parent != null && row?.parent !== "") {
            return true;
        }
        else {
            return false;
        }
    }

    return (
        <Stack direction={'row'} alignItems={'center'}>
            {haveChildSessions() || haveParentSession() ? (
                <Tooltip title={'Sessionen har besläktade körningar'} arrow>
                    <AccountTreeIcon sx={{marginTop: '8px', fontSize: '12px', color: 'GrayText'}} />
                </Tooltip>
            ) : ("")}
        </Stack>
    );
}